import BaseDB from 'libs/DB/BaseDB'

const dataDB = new BaseDB('jmapImageDB', {
  version: 2,
  key: 'hash',
  dataKey: 'blob',
  expireDuration: 30 * 24 * 60 * 60 * 1000,
  skipPreload: true,
  getSaveData: (item) => {
    return {
      ...item,
      url: window.URL.createObjectURL(item.blob),
    }
  },
  beforeRemoveSaveData: (saveData) => {
    if (saveData != null && saveData.url != null) {
      window.URL.revokeObjectURL(saveData.url)
    }
  },
})

export default dataDB
